import { useEffect, useState } from "react";
import ReadAlong from "../../Js/read-along";
import "./style.css";
import { Box } from "@mui/material";

let readAlong = new ReadAlong();

const BookReadAlong = (props) => {
  let [firstLoad, setFirstLoad] = useState(false);
  let [passageTextElm, setPassageTextElm] = useState("");

  useEffect(() => {
    //if(props.data && props.index){
    setReadAlongContainer(props.data.text.words, props.index);
    //}
    //console.log("!@#!@#", props.data.text.words);
  }, [props.data, props.index]);

  useEffect(() => {
    if (firstLoad) {
      play_pause(props.isplay);
    }
  }, [props.isplay]);

  useEffect(() => {
    setFirstLoad(true);
  }, []);

  useEffect(() => {
    //console.log("currentpage+++", +props.currentpage + 1);
  }, [props.currentpage]);

  const setReadAlongContainer = (wordsJson, index) => {
    //console.log("!@#!@#111111111", passageTextElm);
    let pElement = document.createElement("p");

    pElement.setAttribute("style", "margin: 0 !important;");

    let passageText = wordsJson;
    for (let textContent in passageText) {
      let spanElemnt = document.createElement("span");
      spanElemnt.setAttribute("data-begin", passageText[textContent].begin);
      spanElemnt.setAttribute("data-dur", passageText[textContent].duration);
      spanElemnt.innerHTML = passageText[textContent].word;
      pElement.appendChild(spanElemnt);
      if (passageText[textContent].word.indexOf("<p>") > -1) {
        let paragraphElemnt = document.createElement("p");
        paragraphElemnt.style.marginBottom = "10px";
        paragraphElemnt.innerHTML = "";
        pElement.appendChild(paragraphElemnt);
      }
    }
    //let that = this;
    //setTimeout(() => {
    setPassageTextElm(pElement.outerHTML);
    // console.log(document.getElementById('loader_'+index), " : loader5")
    // document.getElementById('loader_'+index).style.display = 'none';
    //}, 350);
  };

  const removePTags = (content) => {
    let newContent = content.replace(/<p><\/p><\/span>/g, "</span>");
    return newContent;
  };

  const play_pause = (isplay) => {
    if ((props.left && props.index == +props.currentpage) || (!props.left && props.index == +props.currentpage + 1)) {
      try {
        var args;
          args = {
            text_element: document.getElementById("passage_" + props.index),
            audio_element: document.getElementById(
              "passage-audio_" + props.index
            ),
            autofocus_current_word: true,
          };
        readAlong.init(args);
      } catch (err) {
        console.log(err, " : error");
      }
      //console.log(this.audio, " : hhhhh");
      var a = document.getElementById("passage-audio_" + props.index);
      console.log("!@#$222333444", isplay);

      if (isplay) {
        //pauseBut = true;
        //playBut = false;
        //this.setInters();
        // document.getElementById("btndiv").style.opacity = "0.5";
        a.play();
      } else {
        //this.pauseBut = false;
        //this.playBut = true;
        // document.getElementById("btndiv").style.opacity = "1";
        a.pause();
      }
      // let that = this;
      a.onended = () => {
        // that.pauseBut = false;
        // that.playBut = true;
        // this.myHeight = 0;
        // this.intervl = null;
        // this.lastOffset = 0;
        // this.alreadyScrolled = 0;
        // this.centerbtn = true;
        // this.unsetIntervl = false;
        // clearInterval(this.intervl);
        // clearInterval(this.innerInterval);
        // document.getElementById("aa").scrollTo(0, 0);
        // document.getElementById("btndiv").style.opacity = "1";
        // document.getElementById("btndiv").style.top = "5px";
        //EventBus.$emit("toggle-read-along-play", true);
        props.togglePlay(false);
      };
    } else {
      var b = document.getElementById("passage-audio_" + props.index);
      b.pause();
    }
  };

  return (
    <div style={{overflow: 'auto'}}>
      <Box
        dangerouslySetInnerHTML={{ __html: removePTags(passageTextElm) }}
        className={
          props.fontSize && props.fontSize == "18px"
            ? "passage paragraphspan initialized animate-fade text-justify fontbtm_14 line_height_1_5_m"
            : "passage paragraphspan initialized animate-fade text-justify line_height_1_5_m"
        }
        id={"passage_" + props.index} 
        sx={{ fontWeight: 400, fontSize: props.fontSize, padding: 2, marginLeft: '20px', height: 'auto', overflow: 'auto',marginRight: '10px','@media (min-width: 1366px)':{fontSize: '1.5vw'}}}
      ></Box>
      {props.data && (
        <audio id={"passage-audio_" + props.index} className="passage">
          <source
            src={`${sessionStorage.getItem('media_url')}audio/${props.data.text.media.audio}`}
            type="audio/mp3"
          />
          <em className="error">
            <strong>Error:</strong> Your browser doesn't appear to support HTML5
            Audio.
          </em>
        </audio>
      )}
    </div>
  );
};

export default BookReadAlong;
